import { createSelector } from 'reselect'
import confirmSelector from 'redux/selectors/confirms/confirm_selector'
import confirmTypes from 'helpers/enums/confirmTypes'

const getFullDataLoaded = state => state.user.fullDataLoaded

const myLibraryNickelTourSelector = createSelector(
	[getFullDataLoaded, confirmSelector],
	(isFullDataLoaded, confirm) => ({
		shouldHideNotification: !isFullDataLoaded || confirm.confirmType === confirmTypes.FEATURE_SCHOOL_JOINED_NOTIFICATION,
	})
)

export default myLibraryNickelTourSelector
